export const LAUNCHDARKLY_TOGGLES = {
  ARCHIVE_VIDEO_TO_PLAYLISTS: 'archiveVideoToPlaylists',
  COMBO_PLAN: 'comboPlan',
  MORE_UPLOAD_VIDEO_CODECS: 'moreUploadVideoCodecs',
  MULTI_UPLOAD_FLOW: 'multiUploadFlow',
  DECODER_REMOTE_ACTIONS: 'decoderRemoteActions',
  DECODER_REMOTE_LOAD: 'decoderRemoteLoad',
  ENCODER_AUTO_INPUT: 'encoderAutoInput',
  ENCODER_CUSTOMER_UPDATE: 'encoderCustomerUpdate',
  ENCODER_4K_INPUT: 'encoder4KInput',
  ERROR_TOASTS: 'errorToasts',
  OBS_VISIBLE: 'obsVisible',
  OPA_MIGRATION: 'opaMigration',
  PRODPAD_FEEDBACK: 'prodpadFeedback',
  SIMPLIFIED_CALENDAR: 'simplifiedCalendar',
  STUDIO_UIUX: 'studioUiux',
  UNIVERSAL_VIDEO_UPLOAD: 'universalVideoUpload',
} as const;
